import React from "react";
import { Image } from "@components/ui/Image";
import classNames from "classnames";

interface Props {
  activeCache?: boolean;
  alt?: string;
  className?: string;
  noMaxWidth?: boolean;
  outline?: boolean;
  size?: number;
}

/**
 * Reusable Image component with flexible size + styling
 *
 * @param {boolean} activeCache - optional prop if your Image supports it
 * @param {string} alt - alt text (optional)
 * @param {string} className - optional extra Tailwind classes
 * @param {boolean} noMaxWidth - disables max-width limit
 * @param {boolean} outline - Outline image or not
 * @param {number|string} size - one of predefined sizes (20, 48, 56) or custom number
 */
const Brush = ({
  alt = "Image",
  size = 48,
  noMaxWidth = false,
  className = "",
  activeCache = true,
  outline = false,
}: Props) => {
  const baseClasses = classNames("object-contain", className, {
    "!max-w-none": noMaxWidth,
  });

  const src = outline
    ? "/img/ic-brush-outline-red.svg"
    : "/img/ic-brush-red.svg";

  return (
    <Image
      src={src}
      alt={alt}
      width={size}
      height={size}
      className={baseClasses}
      activeCache={activeCache}
    />
  );
};

export default Brush;
